var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHumanApproch = function SvgHumanApproch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 80,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F4FE",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M76.087 37.54a36.545 36.545 0 0 1-41.975 36.14 36.543 36.543 0 1 1 41.975-36.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F4FF",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M72.444 53.524a29.987 29.987 0 0 1-8.692 11.424 36.55 36.55 0 0 1-53.831-6.062v-4.531c0-4.809 4.83-8.743 10.724-8.743H61.72c5.886.008 11.918 5.071 10.724 7.912Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M52.606 26.043v.073c.001.812-.057 1.623-.175 2.426-.962 6.965-6.003 12.269-12.079 12.269-6.76 0-12.246-6.557-12.246-14.695v-.138a17.178 17.178 0 0 1 1.209-6.23 14.853 14.853 0 0 1 2.462-4.123c.168-.197.335-.386.51-.568a11.824 11.824 0 0 1 4.714-3.067c1.073-.37 2.2-.56 3.337-.561a11.095 11.095 0 0 1 8.064 3.642c.16.16.314.335.46.51l.05.059a16.13 16.13 0 0 1 3.694 10.403Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M32.286 19.165c0 3.84-1.639 6.958-3.642 6.958a1.78 1.78 0 0 1-.518-.073v-.066a16.232 16.232 0 0 1 3.643-10.352c.35 1.144.525 2.336.517 3.533Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M48.876 15.574c-1.967 3.694-6.514 6.273-11.803 6.273a14.898 14.898 0 0 1-7.759-2.098 14.857 14.857 0 0 1 2.463-4.124c.168-.197.335-.386.51-.568A11.824 11.824 0 0 1 37 11.99c1.073-.37 2.2-.56 3.336-.561a11.096 11.096 0 0 1 8.065 3.643c.175.153.328.327.474.502ZM52.605 26.043c-.17.049-.347.074-.524.073-2.026 0-3.643-3.119-3.643-6.958a11.73 11.73 0 0 1 .51-3.526 16.13 16.13 0 0 1 3.657 10.41Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#04121D",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M60.716 77c7.364 0 13.333-5.97 13.333-13.334 0-7.363-5.969-13.333-13.333-13.333s-13.333 5.97-13.333 13.334S53.353 77 60.716 77Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#21A56E",
    d: "M53.856 62.524a4.04 4.04 0 0 1 3.98-4.151 4.07 4.07 0 0 1 3.3 1.597 4.07 4.07 0 0 1 3.23-1.736 4.04 4.04 0 0 1 4.152 3.98c.085 3.998-7.215 8.754-7.215 8.754s-7.365-4.578-7.447-8.444Z"
  })));
};
export default SvgHumanApproch;